import { FormikErrors, yupToFormErrors } from 'formik'
import { flattenObject } from './index'

const noError = (currentValue: string) => Boolean(currentValue) === false

export const runValidateSchema = (values: Record<string, any>, validationSchema: any): Promise<any> => {
    const promise = validationSchema.validate(values, { abortEarly: false })
    return new Promise((resolve, reject) => {
        promise.then(
            () => {
                resolve({})
            },
            (err: any) => {
                if (err.name === 'ValidationError') {
                    resolve(yupToFormErrors(err))
                } else {
                    // We throw any other errors
                    if (process.env.NODE_ENV !== 'production') {
                        console.warn(
                            `Warning: An unhandled error was caught during validation in <Formik validationSchema />`,
                            err,
                        )
                    }

                    reject(err)
                }
            },
        )
    })
}
export const checkErrorExist = (checkFields: string[], errors: Record<string, any>): boolean => {
    let isErrorExist = false
    checkFields.forEach((field: string) => {
        if (errors[field]) {
            isErrorExist = true
        }
    })
    return isErrorExist
}

export const validateStringOrNumberArrayField = (field: Record<string, number | string>[] | null): boolean => {
    let isValid = true
    if (!field) {
        isValid = false
    }
    if (Array.isArray(field)) {
        if (field.length === 0) {
            isValid = false
        } else {
            field.forEach((value: Record<string, number | string>) => {
                const validateValue = String(value?.value)
                if (!validateValue) {
                    isValid = false
                }
            })
        }
    }
    return isValid
}
export const validateFieldsAreAllPassed = (error: Record<string, string>): boolean => {
    const flatError = flattenObject(error)
    let isAllFieldPass = true
    if (flatError) {
        const errors: string[] = Object.values(flatError)
        isAllFieldPass = errors.every(noError)
    }
    return isAllFieldPass
}
export const setInitialTouched = (source: any) => {
    if (!source) return false
    if (typeof source === 'string' && source.length > 0) {
        return true
    }
    const output: any = {}
    for (const key of Object.keys(source)) {
        output[key] = setInitialTouched(source[key])
    }
    return output
}

interface TransformObjectToDotParams {
    obj: Record<string, string>
    prefix?: string
    result?: string[]
}
/**
 * transform nested object from formik errors into dot notation
 * ex: obj { data: { name: 'Required' } } -> 'data.name'
 */
export const transformObjectToDotNotation = ({ obj, prefix = '', result = [] }: TransformObjectToDotParams) => {
    Object.keys(obj).forEach(key => {
        const value = obj[key]
        if (!value) return

        const nextKey = prefix ? `${prefix}.${key}` : key
        if (typeof value === 'object') {
            transformObjectToDotNotation({ obj: value, prefix: nextKey, result })
        } else {
            result.push(nextKey)
        }
    })

    return result
}

export const getFieldErrorNames = (formikErrors: FormikErrors<unknown>) => {
    return transformObjectToDotNotation({ obj: formikErrors })
}
